import { Component, DestroyRef, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { BookingMessagesService } from '@core/services/booking-messages.service';
import { ActivatedRoute } from '@angular/router';
import { MessageSenderDesignation } from '@core/models/api-response.model';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastService } from '../../services/toast.service';
import { SPOT_TYPE_LABEL, UNDER_MAINTANCE_ERROR, UNDER_MAINTANCE_GREATERTIME, USER_ROLES } from '../../constant/shared.constant';
import { BreadcrumbItem, CompanyService } from '../../services/company.service';
import { SuperAdminService } from '@core/services/super-admin.service';
import { autoUnsubWith } from '@shared/services/utility.abstract';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

@Component({
  selector: 'app-user-messages-section',
  templateUrl: './user-messages.component.html',
  styleUrls: ['./user-messages.component.scss']
})
export class UserMessagesComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  @ViewChild('msgScrollContainer') private readonly msgScrollContainer: ElementRef;
  senderId:string;
  BookingId:string;
  BookingMessageList:any=[];
  bookingDetails:any;
  roleName:string;
  messageGroup:FormGroup;
  messageHistory:any = [];
  senderData:any = []
  defaultBoogingId:string ='';
  paramsBookingId:string = "";
  selectedBookingId:string = "";
  dummy: string = "assets/images/dummy-img.png";
  roles = ['SuperAdmin', 'ParkingOwner', 'ParkingManager'];
  filterData:FormGroup;
  startMessage:boolean = false;
  spotTypeMsg: string = SPOT_TYPE_LABEL;
  userRoles = USER_ROLES;
  constructor(
    private readonly bookingMessageService:BookingMessagesService,
    private readonly route: ActivatedRoute,
    private readonly fb:FormBuilder,
    private readonly toastService: ToastService,
    private readonly companyService: CompanyService,
    private readonly superAdminService: SuperAdminService,
    private readonly encryptStorage: EncryptionStorageService
  ){

    this.messageGroup = this.fb.group({
      messageContent: [""],
    });

    this.filterData = this.fb.group({
      startDateTime: [""],
      endDateTime: [""],
      driverName: [""],
      driverEmail: [""],
      bookingId: [""]
    })
  }

  ngOnInit() {
    this.initializeComponent();
    this.superAdminService.popupClosed$.subscribe(refresh => {
      if (refresh) {
        this.initializeComponent(); // Refresh logic when popup is closed
      }
    });
  }
  
  private initializeComponent(): void {
    const breadcrumbObj: BreadcrumbItem[] = [{ title: 'Messages' }];
    this.companyService.setAdminHeaders('0', breadcrumbObj);
    this.senderId = this.encryptStorage.getItem('id');
    this.roleName = this.encryptStorage.getItem('roleName');
    this.route.queryParams.subscribe(params => {
      this.paramsBookingId = params['id'];
      
      this.getBookingMessageList('firstTime');
      if (this.paramsBookingId) {
        this.getBookingMessage(this.paramsBookingId);
        this.getBookingDetialById(this.paramsBookingId);
      }
    });
  
    this.filterData.reset();
  }

  checkDataTimeValidation() {
    if (this.filterData.get('startDateTime').value && !this.filterData.get('endDateTime').value) {
      this.toastService.showToastMessage('error', 'Error', UNDER_MAINTANCE_ERROR);
      return false;
    } else if (this.filterData.get('startDateTime').value >= this.filterData.get('endDateTime').value && (this.filterData.get('startDateTime').value != null && this.filterData.get('endDateTime').value != null)) {
      this.toastService.showToastMessage('error', 'Error', UNDER_MAINTANCE_GREATERTIME);
      return false;
    } else if (!this.filterData.get('startDateTime').value && this.filterData.get('endDateTime').value) {
      this.toastService.showToastMessage('error', 'Error', UNDER_MAINTANCE_ERROR);
      return false;
    }
    return true;
  }

  getBookingMessageList(_changeAction:string){
      
      let data = {
        companyId: null,
        startDate: this.filterData.get('startDateTime').value || '',
        endDate: this.filterData.get('endDateTime').value || '',
        driverName: this.filterData.get('driverName').value || '',
        email: this.filterData.get('driverEmail').value || '',
        invoiceNumber: this.filterData.get('bookingId').value || ''
      }
      this.selectedBookingId = ""
      this.bookingMessageService.getBookingMessageList(data).pipe(autoUnsubWith(this.destroyRef)).subscribe({
        next:(res) =>{
          
          this.BookingMessageList = res.data;
          if (this.BookingMessageList.length > 0 && this.paramsBookingId === "" || this.paramsBookingId ===undefined) {
            this.getBookingMessage((this.selectedBookingId)?this.selectedBookingId:this.BookingMessageList[0].bookingId);
          }

          if(this.paramsBookingId && this.BookingMessageList.length > 0){
            this.getBookingDetialById(this.paramsBookingId);
          }
        
        },error:(_error) =>{
          this.BookingMessageList = [];
          this.messageHistory = [];
        }
      })
  }

  searchByFilter(){
    if (this.checkDataTimeValidation()) {
      this.startMessage = false;
      this.getBookingMessageList('search');
    }
  }

  getMessageSenderDesignation(roleName: string): MessageSenderDesignation | null {
    switch (roleName) {
      case this.userRoles.DRIVER:
        return MessageSenderDesignation.Driver;
      case this.userRoles.SUPER_ADMIN:
        return MessageSenderDesignation.SuperAdmin;
      case this.userRoles.PARKING_OWNER:
        return MessageSenderDesignation.ParkingOwner;
      case this.userRoles.PARKING_MANAGER:
        return MessageSenderDesignation.ParkingManager;
      default:
        return null; // Return null if the role is unknown
    }
  };

  getBookingMessage(bookingId){
    
    this.selectedBookingId = bookingId;
    let id ={
      bookingId:bookingId
    }
    this.bookingMessageService.getBookingMessage(id).pipe(autoUnsubWith(this.destroyRef)).subscribe({
    next:(response:any) =>{
      
      this.messageHistory = response.data;
      this.paramsBookingId = ""; 
      this.getBookingDetialById(bookingId);
    
    }, error:(_error) =>{
      this.messageHistory = [];
    }
    })
  };

  createMessage(){
    let messageContent = this.messageGroup.get('messageContent').value;
   
    if (!messageContent || messageContent.trim() === '') {
      return;
    }
      let roleName = this.encryptStorage.getItem('roleName');
      let messageSenderDesignation = this.getMessageSenderDesignation(roleName);
      let data ={
        senderId:this.senderId,
        bookingId:this.selectedBookingId,
        content:this.messageGroup.get('messageContent').value,
        messageSenderDesignation:messageSenderDesignation
  
      }
      this.bookingMessageService.createBookingMessage(data).pipe(autoUnsubWith(this.destroyRef)).subscribe({
        next:(_res) =>{
          this.getBookingMessage(this.selectedBookingId);
          this.messageGroup.reset();
          this.getBookingMessageList('createMessage');
        },
      })
  };

  getBookingDetialById(bookingId:any){
    
    this.selectedBookingId = bookingId;
    let id = bookingId;
    this.bookingMessageService.getBookingDetailById(id).pipe(autoUnsubWith(this.destroyRef)).subscribe({
      next:(response) => {
        
        this.bookingDetails = response;
        this.scrollToBottom();
      }, error:() =>{
        this.bookingDetails = null;
              }
    })
  };

  isRoleInList(role: string): boolean {
    return this.roles.includes(role);
}

resetFilter(){
  this.filterData.reset();
  this.getBookingMessageList('reset');
  if(this.paramsBookingId){
    this.getBookingMessage(this.paramsBookingId);
    this.getBookingDetialById(this.paramsBookingId);
};
}

getMessageDisplayName(role: string, name: string): string {
  if (this.roleName === role) {
    return 'You';
  }

  if (this.roleName === USER_ROLES.SUPER_ADMIN) {
    switch (role) {
      case USER_ROLES.DRIVER: return name;
      case USER_ROLES.PARKING_OWNER: return 'Parking Admin';
      case USER_ROLES.PARKING_MANAGER: return 'Parking Manager';
      default: return name;
    }
  }

  if (this.roleName === USER_ROLES.PARKING_OWNER) {
    switch (role) {
      case USER_ROLES.DRIVER: return name;
      case USER_ROLES.SUPER_ADMIN: return 'Super Admin';
      case USER_ROLES.PARKING_MANAGER: return 'Parking Manager';
      default: return name;
    }
  }

  if (this.roleName === USER_ROLES.PARKING_MANAGER) {
    switch (role) {
      case USER_ROLES.DRIVER: return name;
      case USER_ROLES.SUPER_ADMIN: return 'Super Admin';
      case USER_ROLES.PARKING_OWNER: return 'Parking Admin';
      default: return name;
    }
  }

  if (this.roleName ===USER_ROLES.DRIVER) {
    return 'Support';
  }

  return name;
};

hideFilterForDriver(){
  if(this.roleName === USER_ROLES.DRIVER){
    return false;
  }
  return true
};

scrollToBottom(): void {
  
    this.msgScrollContainer?.nativeElement.scrollTo({
      top: this.msgScrollContainer?.nativeElement.scrollHeight,
      behavior: 'smooth'
    });
  }

startMessageWithUser(){
  if(this.messageHistory.length <=0)
     this.startMessage = true;
}

startMessageButtonCheck(){
    if((this.BookingMessageList?.length > 0 || this.paramsBookingId) && this.bookingDetails !=null){
    return true;
  } 
  return false;
}
}